(function () {
    angular.module('active-website-activity-condition.dir', ['ngclipboard'])
        .directive('activeWebsiteActivityCondition', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeWebsiteActivityCondition]);

    function activeWebsiteActivityCondition($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = () => {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.specificUrlOptions = [
                    {
                        value: 'any-tracked-page',
                        message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                    },
                    {
                        value: 'is-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                    },
                    {
                        value: 'contains-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                    },
                    {
                        value: 'doesnotcontain-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                    },
                    {
                        value: 'startswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                    },
                    {
                        value: 'endswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                    },
                    {
                        value: 'wildcardmatch-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                    }
                ];

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                    }
                    $scope.displaySubMenu = false;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function() {
                    $scope.contMenuConfigs = 0;
                };
                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                };

                $scope.displayTrackerModal = () => {
                    $rootScope.$emit('displayTrackerModal');
                };
            }],
            link: function (scope, elem, attr) {
                //Setting initial form on true to display radio buttons
                scope.displayForm = true;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-website-activity');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });
                }

            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/conditions/active-website-activity-condition.js